module.exports = __webpack_public_path__ + "img/20.4f2f4514.png";